import { render } from "./ProductBlock.vue?vue&type=template&id=50713e60"
import script from "./ProductBlock.vue?vue&type=script&lang=js"
export * from "./ProductBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__